module.exports = __webpack_public_path__ + "static/media/icon-observations.4f87ce9c.svg";